/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes,extraRequire}
 * tslint:disable
 */
var styles = [".stats-table[_ngcontent-%COMP%]{margin:.5rem;overflow-y:scroll;width:800px}.stats-table[_ngcontent-%COMP%]   table[_ngcontent-%COMP%]{width:100%;table-layout:fixed}"];
export { styles as styles };

